<template>
  <div
    class="a-transition-fade m-card-primary m-login"
  >
    <p>La academia <b>{{ licenciaPublicaDetallada.academia_nombre }}</b> a la que intentas acceder está temporalmente inactiva.</p>
    <p>Si tienes alguna duda o inquietud, por favor comunícate con el administrador de la academia a través del siguiente correo: <b>{{ licenciaPublicaDetallada.email_propietario }}</b>.</p>
  </div>
</template>

<script>

export default {
  name: 'MoleculeLoginDisabled',

  props: {
    licenciaPublicaDetallada: Object
  }
}
</script>
